var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.activeTool
    ? _c(
        "v-layout",
        {
          staticClass: "home-footer-info",
          staticStyle: { flex: "none" },
          attrs: { id: "current-tool" }
        },
        [
          _vm.activeTool === "fc_building"
            ? _c("BuildingFillSVG", { staticClass: "bottomToolsSVG" })
            : _vm._e(),
          _vm._v(" "),
          _vm.activeTool === "fc_pole"
            ? _c("PoleFillSVG", { staticClass: "bottomToolsSVG" })
            : _vm._e(),
          _vm._v(" "),
          _vm.activeTool === "fc_manhole"
            ? _c("ChambreFillSVG", { staticClass: "bottomToolsSVG" })
            : _vm._e(),
          _vm._v(" "),
          _vm.activeTool === "fc_pathway"
            ? _c("InfraFillSVG", { staticClass: "bottomToolsSVG" })
            : _vm._e(),
          _vm._v(" "),
          _vm.activeTool === "fc_cable"
            ? _c("CableFillSVG", { staticClass: "bottomToolsSVG" })
            : _vm._e(),
          _vm._v(" "),
          _vm.activeTool === "fc_cabinet"
            ? _c("CabinetFillSVG", { staticClass: "bottomToolsSVG" })
            : _vm._e(),
          _vm._v(" "),
          _vm.activeTool === "fc_closure"
            ? _c("ClosureFillSVG", { staticClass: "bottomToolsSVG" })
            : _vm._e(),
          _vm._v(" "),
          _vm.activeTool === "fc_fiber_terminal_box"
            ? _c("ClusterFillSVG", { staticClass: "bottomToolsSVG" })
            : _vm._e(),
          _vm._v(" "),
          _vm.activeTool === "fc_cluster_tool"
            ? _c("ClusterToolFillSVG", { staticClass: "bottomToolsSVG" })
            : _vm._e(),
          _vm._v(" "),
          _vm.activeTool === "fc_site"
            ? _c("TowerFillSVG", { staticClass: "bottomToolsSVG" })
            : _vm._e(),
          _vm._v(" "),
          _vm.activeTool === "fc_cell"
            ? _c("CellFillSVG", { staticClass: "bottomToolsSVG" })
            : _vm._e(),
          _vm._v(" "),
          _vm.activeTool === "fc_toby_box"
            ? _c("TobyBoxFillSVG", { staticClass: "bottomToolsSVG" })
            : _vm._e(),
          _vm._v(" "),
          _vm.activeTool === "fc_fiber_distribution_point"
            ? _c("PNFillSVG", { staticClass: "bottomToolsSVG" })
            : _vm._e(),
          _vm._v(" "),
          _vm.activeTool === "fc_optical_line_termination"
            ? _c("COFillSVG", { staticClass: "bottomToolsSVG" })
            : _vm._e(),
          _vm._v(" "),
          _vm.activeTool === "fc_technical_local"
            ? _c("TechLocalFillSVG", { staticClass: "bottomToolsSVG" })
            : _vm._e(),
          _vm._v(" "),
          _vm.activeTool === "fc_fdp_zone"
            ? _c("PNAreaFillSVG", { staticClass: "bottomToolsSVG" })
            : _vm._e(),
          _vm._v(" "),
          _vm.activeTool === "fc_olt_zone"
            ? _c("COAreaFillSVG", { staticClass: "bottomToolsSVG" })
            : _vm._e(),
          _vm._v(" "),
          _vm.activeTool === "fc_annotation_zone"
            ? _c("OtherAreaFillSVG", { staticClass: "bottomToolsSVG" })
            : _vm._e(),
          _vm._v(" "),
          _vm.activeTool === "fc_closure_zone"
            ? _c("ClosureAreaFillSVG", { staticClass: "bottomToolsSVG" })
            : _vm._e(),
          _vm._v(" "),
          _vm.activeTool === "fc_annotation_point"
            ? _c("AnnotationPointFillSVG", { staticClass: "bottomToolsSVG" })
            : _vm._e(),
          _vm._v(" "),
          _vm.activeTool === "fc_field_cable"
            ? _c("FieldCableFillSVG", { staticClass: "bottomToolsSVG" })
            : _vm._e(),
          _vm._v(" "),
          _vm.activeTool === "fc_slack"
            ? _c("SlackFillSVG", { staticClass: "bottomToolsSVG" })
            : _vm._e(),
          _vm._v(" "),
          _vm.activeTool === "fc_asset_reservation"
            ? _c("AssetReservationFillSVG", { staticClass: "bottomToolsSVG" })
            : _vm._e(),
          _vm._v(" "),
          _vm.activeTool === "fc_bulk_tp"
            ? _c("BulkTPFillSVG", { staticClass: "bottomToolsSVG" })
            : _vm._e(),
          _vm._v(" "),
          _vm.activeTool === "Point"
            ? _c("PointFillSVG", {
                staticClass: "bottomToolsSVG",
                attrs: { id: "bottomPoint" }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.activeTool === "LineString"
            ? _c("LineFillSVG", {
                staticClass: "bottomToolsSVG line",
                attrs: { id: "bottomLine" }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.activeTool === "Polygon"
            ? _c("PolygonFillSVG", {
                staticClass: "bottomToolsSVG polygon",
                attrs: { id: "bottomPolygon" }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.activeTool === "fc_microduct_bundle"
            ? _c("BundleFillSVG", { staticClass: "bottomToolsSVG" })
            : _vm._e(),
          _vm._v(" "),
          _vm.activeTool === "fc_virtual"
            ? _c("VirtualFillSVG", { staticClass: "bottomToolsSVG" })
            : _vm._e(),
          _vm._v(" "),
          _vm.activeTool === "fc_blockage"
            ? _c("BlockageFillSVG", { staticClass: "bottomToolsSVG" })
            : _vm._e(),
          _vm._v(" "),
          _vm.activeTool === "Copy"
            ? _c("CopySVG", { staticClass: "bottomToolsSVG" })
            : _vm._e(),
          _vm._v(" "),
          _vm.activeTool === "Paste"
            ? _c("PasteSVG", { staticClass: "bottomToolsSVG" })
            : _vm._e(),
          _vm._v(" "),
          _vm.activeTool === "Delete"
            ? _c("DeleteSVG", { staticClass: "bottomToolsSVG" })
            : _vm._e(),
          _vm._v(" "),
          _vm.activeTool === "external_import"
            ? _c("ExternalImportFillSVG", { staticClass: "bottomToolsSVG" })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                "padding-left": "4px",
                "text-transform": "uppercase"
              }
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(_vm.$tc(_vm.getTranslationKey(_vm.activeTool), 1)) +
                  "\n  "
              )
            ]
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-523026b2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-523026b2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Footer/ActiveTool.vue
// module id = null
// module chunks = 